import UpdatePassword from "@/features/auth/components/UpdatePassword";
import { createFileRoute } from "@tanstack/react-router";
import { hooks as h } from "@/hooks";

const ChangePasswordPage = () => {
    h.useNav([
        { label: "Profile", route: { to: "/profile" } },
        { label: "Change Password", route: { to: "/profile/change-password" } },
    ]);

    return <UpdatePassword successTo="/profile" />;
};

export const Route = createFileRoute("/_app/profile/change-password")({
    component: ChangePasswordPage,
});
